import { useIntl } from 'react-intl';
import { useRouter } from 'next/navigation';
import { useSWRConfig } from 'swr';
import { useLoginApi } from './LoginApi';

export const useLogout = () => {
  const { locale } = useIntl();
  const loginApi = useLoginApi();
  const { mutate } = useSWRConfig();
  const { push } = useRouter();

  const logout = async () => {
    const { apiKeyManager } = await import('@empiriecom/mybuy-session');
    if (loginApi) {
      try {
        const response = await loginApi.logout({ ecLocale: locale });
        await apiKeyManager.logout(response);
        push('/');
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (e) {
        await apiKeyManager.logout();
        push('/');
      } finally {
        mutate('session');
      }
    } else {
      throw new Error('tried to access loginApi before it was initialized');
    }
  };

  return {
    logout,
  };
};
